import { useToastContext } from "./ToastContext";

export const useToast = () => {
  const { addToast } = useToastContext();

  return {
    success: (msg, duration) => addToast(msg, "success", duration),
    error:   (msg, duration) => addToast(msg, "error",   duration),
    info:    (msg, duration) => addToast(msg, "info",    duration),
    warning: (msg, duration) => addToast(msg, "warning", duration),
  };
};
